import { render } from "./MetalView.vue?vue&type=template&id=703a139a"
import script from "./MetalView.vue?vue&type=script&lang=js"
export * from "./MetalView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__